export const fr = {
  // Common
  common: {
    back: "Retour",
    next: "Suivant",
    save: "Sauver",
    saved: "Sauvé ✓",
    delete: "Supprimer",
    loading: "Chargement...",
    error: "Erreur",
    share: "Partager",
    linkCopied: "Lien copié !",
    perPerson: "par personne",
    perNight: "/nuit",
    days: "jours",
    day: "jour",
    travelers: "voyageurs",
    traveler: "voyageur",
    planTrip: "Planifier un voyage",
    letsGo: "C'est parti !",
    continue: "Continuer",
    book: "Réserver",
    reviews: "avis",
    live: "En direct",
    or: "ou par email",
    confirm: "Confirmer",
    cancel: "Annuler",
    close: "Fermer",
    search: "Rechercher",
    yes: "Oui",
    no: "Non",
    appLoading: "Chargement…",
    sessionExpired: "Votre session a expiré. Vous êtes déconnecté.",
    signedOut: "Vous êtes déconnecté",
    seasonLow: "Basse saison",
    seasonHigh: "Haute saison",
    seasonTip: "Astuce saison",
    paywallSingleActive: "Recherche unique active — expire le {date}",
    paywallNoAccess: "Accès limité — choisissez une formule",
    paywallFreeAvailable: "Formule Découverte : 1 itinéraire gratuit ce mois-ci",
    paywallFreeUsed: "Itinéraire gratuit du mois utilisé — revenez le mois prochain ou débloquez plus de recherches",
    paywallUpgrade: "Passer à un abonnement",
    paywallSingleExpired: "Recherche unique expirée le {date}",
    paywallRenew: "Renouveler",
    countryTopicsTitle: "Récits par",
    countryTopicsHighlight: "pays",
    countryTopicsSubtitle: "Cliquez sur un pays pour ouvrir la discussion correspondante.",
    dismiss: "OK",
    previous: "Précédent",
  },

  notif: {
    title: "Notifications",
    markAllRead: "Tout marquer lu",
    empty: "Aucune notification",
    reply: "Nouvelle réponse à ton commentaire",
    comment: "Nouveau commentaire sur ton sujet",
    filterAll: "Tout",
    filterComments: "Commentaires",
    filterReplies: "Réponses",
  },

  seasons: {
    tag: "Météo en direct",
    title: "Quand partir ?",
    highlight: "saisons live",
    subtitle: "Données climatiques réelles via API météo, mises à jour automatiquement.",
    recoLow: "À privilégier maintenant",
    recoHigh: "Foule attendue actuellement",
    recoNeutral: "Saison intermédiaire",
  },

  calendar: {
    viewList: "Liste",
    viewCalendar: "Calendrier",
    saveDraft: "Brouillon",
    updateDraft: "Mettre à jour",
    draftSaved: "Brouillon sauvegardé",
    draftError: "Échec de la sauvegarde",
    loginToSave: "Connecte-toi pour sauvegarder",
    addActivity: "Activité",
    addPrompt: "Nom de l'activité ?",
    empty: "Aucune activité prévue.",
    removed: "Activité retirée",
    dndHint: "Glisse pour réordonner ou déposer sur un autre jour.",
    movedToDay: "Activité déplacée",
    regenerate: "Régénérer",
    regenerated: "Itinéraire régénéré",
    daysKept: "jours conservés",
    regenConfirmTitle: "Régénérer l'itinéraire ?",
    regenConfirmDesc: "Tes modifications sur {n} jour(s) seront conservées. Les autres jours seront recréés selon tes préférences.",
    keepTastes: "Garder mes goûts",
    lockPrefs: "Verrouiller mes goûts (évite la variation au tirage)",
    tastesLocked: "Goûts verrouillés",
    unlockPrefs: "Préférences verrouillées : décocher pour autoriser la variation",
    untitledActivity: "Activité",
    dragHandle: "Glisser",
    removeActivity: "Supprimer",
  },

  allInOne: {
    tag: "Tout-en-un",
    title: "Ta vie de voyageur,",
    highlight: "réunie",
    subtitle: "Carte interactive, topics par pays, notifications temps réel : tout ce qu'il te faut au même endroit.",
    f1Title: "Carte interactive",
    f1Desc: "Marque les pays visités, zoome librement, ajoute un récit en quelques clics.",
    f2Title: "Topics auto par pays",
    f2Desc: "Chaque pays ajouté ouvre un sujet de discussion enrichi par la communauté.",
    f3Title: "Notifications live",
    f3Desc: "Alertes in-app temps réel pour les commentaires et réponses, filtrables par type.",
    f4Title: "Profil voyageur",
    f4Desc: "Bio, avatar, voyages partagés et carte publique consultable par d'autres voyageurs.",
    f5Title: "Paywall flexible",
    f5Desc: "Une recherche unique 7 jours, abonnements mensuels ou annuels — change quand tu veux.",
    f6Title: "Hors-ligne",
    f6Desc: "Tes itinéraires sauvés restent accessibles même sans connexion.",
  },

  // Header / Nav
  nav: {
    myTrips: "Mes voyages",
    myLists: "Mes listes",
    login: "Connexion",
    logout: "Déco",
    settings: "Paramètres",
    search: "Recherche",
    newTrip: "Nouveau voyage",
    profile: "Profil",
    dashboard: "Tableau de bord",
    signIn: "Connexion",
    signUp: "Inscription",
    signOut: "Se déconnecter",
    notSignedIn: "Non connecté",
    discover: "Découvrir",
    account: "Mon compte",
    about: "À propos",
    discussion: "Discussion",
  },

  // Homepage
  home: {
    title: "Préparez votre",
    titleHighlight: "Grand Départ",
    subtitle: "Votre voyage sur mesure en quelques clics : villes, pays ou road trips, selon vos envies.",
    roadTripMode: "Mode Road Trip",
    roadTripDesc: "Plusieurs villes en voiture",
    departure: "Départ",
    viewGuide: "Voir le guide",
    noGuideYet: "Pas encore de guide",
    countryUndetected: "Pays non identifié — vérifiez l'orthographe",
    onlinePlaces: "Autres lieux (recherche en ligne)",
    guidePreviewTitle: "Aperçu du guide",
    viewFullGuide: "Voir le guide complet",
    recommendedDuration: "Durée conseillée",
    budgetEstimate: "Budget/jour",
    customizeInterests: "Centres d'intérêt",
    pickInterests: "Choisis tes centres d'intérêt",
    generatePreview: "Générer un aperçu",
    refreshPreview: "Actualiser l'aperçu",
    dailyHighlights: "Aperçu jour par jour",
    planMyItinerary: "Planifier mon itinéraire",
    durationIdeal: "Durée idéale pour ce pays",
    durationTooShort: "Séjour un peu court",
    durationLong: "Séjour très long, prévoyez plusieurs régions",
    idealLabel: "idéal",
    fillFieldsFirst: "Renseigne d'abord départ, destination et dates.",
    interests: {
      label: "Intérêts",
      culture: "Culture",
      food: "Gastronomie",
      nature: "Nature",
      beach: "Plages",
      adventure: "Aventure",
      nightlife: "Vie nocturne",
      shopping: "Shopping",
      family: "Famille",
    },
    destination: "Destination",
    departurePlaceholder: "Paris, Lyon, Toulouse...",
    destinationPlaceholder: "Maroc, Barcelone, Japon...",
    dates: "Dates du séjour",
    selectDates: "Sélectionner les dates",
    travelers: "Voyageurs",
    accommodationIncluded: "Hébergement inclus",
    accommodationDesc: "Suggestions d'hébergement dans l'itinéraire",
    accommodationBudget: "Budget hébergement",
    addStop: "Ajouter une étape",
    vehicleType: "Type de véhicule",
    fuelEstimate: "Estimation basée sur",
    fuelSuffix: "L/100km à 1,75€/L",
    departureTime: "Heure de départ",
    departureTimeHint: "Utilisée pour calculer les heures de route, de pauses et d'arrivée.",
    fuel: "carburant",
    arrivalLabel: "Arrivée",
    stopLabel: "Étape",
    popularTitle: "Destinations",
    popularHighlight: "populaires",
    popularSubtitle: "Laissez-vous inspirer pour votre prochain voyage",
    trendingTitle: "Destinations",
    trendingHighlight: "tendances",
    trendingSubtitle: "Les destinations du moment les plus recherchées",
    recommendedTitle: "On vous",
    recommendedHighlight: "conseille",
    recommendedSubtitle: "Des pépites méconnues pour des voyages inoubliables",
    plane: "Avion",
    train: "Train",
    boat: "Bateau",
    car: "Voiture",
    randomDestination: "Destination aléatoire",
    destinationAlt: "destination de voyage",
    trendingBadge: "Tendance",
    logoAlt: "Logo Globr — planificateur de voyage",
    decreaseTravelers: "Diminuer le nombre de voyageurs",
    increaseTravelers: "Augmenter le nombre de voyageurs",
    roadTripPaywallMessage: "Les road trips sont disponibles à partir du forfait Voyageur.",
    viewPlansAction: "Voir les forfaits",
    stopsQuotaPrefix: "Votre forfait",
    stopsQuotaMiddle: "autorise jusqu'à",
    stopsQuotaUnit: "étape(s).",
    stopsQuotaSuffix: "Passez à un forfait supérieur pour en ajouter plus.",
    maxStopsReached: "Nombre maximum d'étapes atteint",
    maxStopsReachedFor: "pour le forfait",
    upgradeButton: "Améliorer",
    seasonAnalyzing: "Analyse de la meilleure période pour",
    seasonLowHint: "moins de touristes, meilleurs prix",
  },

  // Surprise destination quiz
  surprise: {
    button: "Destination surprise",
    title: "Trouve ma destination surprise",
    subtitle: "Réponds à 6 questions, on te suggère le voyage idéal.",
    resultSubtitle: "Voici la destination qui te ressemble ✨",
    searching: "On cherche la destination idéale pour toi...",
    bestTime: "Meilleure période",
    highlights: "À ne pas manquer",
    retry: "Recommencer",
    useDestination: "Utiliser cette destination",
    errorTitle: "Oups",
    errorDesc: "Impossible de trouver une destination, réessaie.",
    q: {
      vibe: "Quelle ambiance recherches-tu ?",
      climate: "Quel climat préfères-tu ?",
      budget: "Quel est ton budget ?",
      duration: "Combien de temps pars-tu ?",
      activity: "Ton activité favorite ?",
      continent: "Une préférence de continent ?",
    },
    vibe: {
      relax: "Détente totale",
      adventure: "Aventure",
      culture: "Culture",
      party: "Festif",
      romantic: "Romantique",
      family: "En famille",
    },
    climate: {
      tropical: "Tropical & chaud",
      mild: "Doux & ensoleillé",
      cold: "Frais ou froid",
      any: "Peu importe",
    },
    budget: {
      low: "Petit budget",
      mid: "Confort",
      high: "Premium",
    },
    duration: {
      short: "Week-end",
      medium: "1-2 semaines",
      long: "3 semaines+",
    },
    activity: {
      beach: "Plage",
      hiking: "Randonnée",
      food: "Gastronomie",
      history: "Histoire",
      city: "Ville",
      wildlife: "Faune sauvage",
    },
    continent: {
      europe: "Europe",
      asia: "Asie",
      americas: "Amériques",
      africa: "Afrique",
      oceania: "Océanie",
      any: "Surprends-moi",
    },
  },

  // Budget options
  budget: {
    budget: "Moins cher",
    budgetDesc: "Le meilleur prix",
    value: "Qualité / Prix",
    valueDesc: "Bon compromis",
    luxury: "Luxe",
    luxuryDesc: "Premium & confort",
    unique: "Atypique",
    uniqueDesc: "Expériences uniques",
    camping: "Camping",
    campingDesc: "Belle étoile & van",
    autoFix: "Auto-ajuster ce jour",
    autoFixed: "Réglages appliqués : tempo « tranquille » et activité la plus chère retirée.",
    exceedTitle: "Budget journalier dépassé",
  },

  // Questionnaire
  questionnaire: {
    selectAll: "Sélectionnez tout ce qui vous correspond",
    refineOptional: "Affiner (facultatif)",
    selectOne: "Choisissez une option",
    createItinerary: "Créer l'itinéraire",
    createRoadTrip: "Créer le road trip",
    interests: "Centres d'intérêt",
    style: "Style de voyage",
    pace: "Rythme du voyage",
    foodPref: "Préférences culinaires",
    mobility: "Mobilité & accessibilité",
    accommodation: "Hébergement préféré",
    vibe: "Ambiance recherchée",
    avoid: "Ce que tu veux éviter",
    dailyBudget: "Budget quotidien (par personne)",
    languages: "Langues parlées",
    culture: "🏛️ Culture & Musées",
    nature: "🌿 Nature & Randonnée",
    food: "🍽️ Gastronomie locale",
    nightlife: "🌙 Vie nocturne",
    shopping: "🛍️ Shopping",
    beach: "🏖️ Plage & Farniente",
    adventure: "🧗 Sports & Aventure",
    photo: "📸 Photographie",
    history: "📜 Histoire & Patrimoine",
    art: "🎨 Art & Street art",
    wellness: "🧘 Bien-être & Spa",
    wildlife: "🦁 Faune & Safari",
    offbeat: "🗺️ Lieux moins touristiques",
    backpacker: "🎒 Backpacker / Économique",
    comfort: "🏨 Confort",
    luxuryStyle: "💎 Luxe & Premium",
    local: "🏡 Chez l'habitant / Authentique",
    chill: "Tranquille — Profiter sans se presser",
    balanced: "Équilibré — Mix visites & repos",
    intense: "Intense — Voir un max de choses",
    streetFood: "🥙 Street food & marchés",
    localCuisine: "🍲 Cuisine locale traditionnelle",
    fineDining: "🍷 Restaurants gastronomiques",
    vegetarian: "🥗 Végétarien / Vegan",
    cafe: "☕ Cafés & brunchs",
    noConstraint: "🚶 Aucune contrainte",
    limitedWalking: "🦶 Marche limitée",
    wheelchair: "♿ Accessibilité PMR",
    stroller: "👶 Poussette",
    pet: "🐕 Avec un animal",
    hotel: "🏨 Hôtel",
    airbnb: "🏠 Airbnb / Location",
    hostel: "🛏️ Auberge de jeunesse",
    campingAccom: "⛺ Camping / Van",
    boutique: "✨ Hôtel boutique / Riad",
    romantic: "💕 Romantique",
    family: "👨‍👩‍👧 Famille",
    friends: "🎉 Entre amis / Festif",
    solo: "🧭 Solo / Introspection",
    hiddenGems: "💎 Hors des sentiers battus",
    instagram: "📱 Spots instagrammables",
    crowds: "👥 Foules & files d'attente",
    touristTraps: "🪤 Pièges à touristes",
    longWalks: "🦿 Longues marches",
    earlyMornings: "😴 Réveils tôt",
    nothing: "✅ Rien de particulier",
    budgetFree: "Gratuit — Activités gratuites uniquement",
    budgetLow: "< 30€/jour/pers.",
    budgetMid: "30-80€/jour/pers.",
    budgetHigh: "80-150€/jour/pers.",
    budgetPremium: "150€+/jour/pers.",
    frenchOnly: "🇫🇷 Français uniquement",
    english: "🇬🇧 Anglais",
    spanish: "🇪🇸 Espagnol",
    localBasics: "🗣️ Notions de la langue locale",
    multilingual: "🌍 Multilingue",
    activitiesPerDay: "Activités par jour",
    activities3to4: "3-4 — Rythme tranquille",
    activities5to6: "5-6 — Rythme modéré",
    activities7to8: "7-8 — Rythme soutenu",
    activities9plus: "9+ — Rythme intense",
    beachLakeDay: "Journée plage / baignade",
    beachLakeDayDesc: "Souhaitez-vous une journée plage ou baignade en lac ?",
    beachNone: "Non merci",
    beachHalfDay: "Demi-journée plage / lac",
    beachFullDay: "Journée complète plage / lac",
    beachMultiple: "Plusieurs journées plage / lac",
    daySchedule: "Horaires de la journée",
    dayScheduleDesc: "À quelle heure souhaitez-vous commencer et finir ?",
    schedule8to20: "8h — 20h (Lève-tôt)",
    schedule9to21: "9h — 21h (Standard)",
    schedule10to22: "10h — 22h (Flexible)",
    schedule10to23: "10h — 23h (Noctambule)",
    schedule11toMid: "11h — Minuit (Fêtard)",
    restDays: "Jours de repos",
    restDays0: "Aucun — programme complet",
    restDays1: "1 jour de pause",
    restDays2: "2 jours de pause",
    restDays3: "3 jours de pause",
  },

  // Loading
  loading: {
    roadTrip: "Planification du road trip...",
    itinerary: "Création de votre itinéraire...",
    preparing: "Préparation de votre aventure à",
    step1: "Analyse de la destination...",
    step2: "Recherche des meilleurs spots...",
    step3: "Sélection des restaurants...",
    step4: "Finalisation de l'itinéraire...",
    step5: "Sélection des hébergements...",
    factDuration: "Durée",
    factDates: "Dates",
    factCurrency: "Devise",
    factVisa: "Visa",
    visaRequired: "Requis",
    visaFree: "Non requis",
    previewDays: "Aperçu de votre itinéraire",
    galleryTitle: "Aperçu de la destination",
    gallery: {
      monuments: "Monuments",
      beaches: "Plages",
      neighborhoods: "Quartiers",
      activities: "Activités",
      food: "Gastronomie",
      nature: "Nature",
    },
    galleryCaptions: {
      monuments: {
        default: "Joyaux historiques de {dest}",
        culture: "Patrimoine vivant à explorer",
        history: "Sur les traces du passé de {dest}",
        art: "Architecture et art à ciel ouvert",
        photo: "Spots iconiques pour vos clichés",
        offbeat: "Monuments confidentiels et oubliés",
      },
      beaches: {
        default: "Côtes et eaux turquoise de {dest}",
        beach: "Plages parfaites pour se détendre",
        wellness: "Criques calmes pour décompresser",
        adventure: "Spots de surf, snorkeling et plongée",
        photo: "Couchers de soleil à couper le souffle",
        offbeat: "Plages secrètes loin des foules",
      },
      neighborhoods: {
        default: "Quartiers à arpenter à {dest}",
        culture: "Ruelles chargées d'histoire et d'âme",
        offbeat: "Quartiers locaux, loin des sentiers battus",
        shopping: "Boutiques, marchés et créateurs",
        art: "Street art et galeries indépendantes",
        photo: "Façades et ambiances ultra-photogéniques",
      },
      activities: {
        default: "Expériences à vivre à {dest}",
        adventure: "Sensations fortes et défis en plein air",
        wellness: "Pauses bien-être et spa",
        nightlife: "La nuit s'anime à {dest}",
        family: "Activités à partager en famille",
        offbeat: "Expériences uniques et insolites",
      },
      food: {
        default: "Saveurs incontournables de {dest}",
        food: "Tables, marchés et spécialités locales",
        nightlife: "Bars et adresses qui ne dorment jamais",
        offbeat: "Cantines secrètes et tables de quartier",
        culture: "La cuisine, miroir de la culture locale",
      },
      nature: {
        default: "Paysages naturels autour de {dest}",
        nature: "Espaces sauvages et grands panoramas",
        adventure: "Randos, sommets et aventures outdoor",
        wildlife: "Faune et flore à observer",
        wellness: "Échappées vertes pour respirer",
        photo: "Décors grandioses pour la photo",
      },
    },
    editCaption: "Modifier la légende",
    saveCaption: "Enregistrer",
    resetCaption: "Réinitialiser",
    captionPlaceholder: "Votre légende personnalisée…",
    validateTitle: "Validez votre aperçu",
    validateSubtitle: "Ajustez les légendes puis lancez la génération",
    confirmAndGenerate: "Confirmer et générer",
    backToQuestions: "Retour aux questions",
    contributingTags: "Inspiré par",
    customCaption: "Personnalisée",
    tipsTitle: "Le saviez-vous ?",
    tipsSourceGuide: "Tiré du guide local de {destination}",
    tipsSourceVerified: "Source vérifiée",
    tipsSourceLoading: "Lecture du guide de la destination…",
    // Étape 1 — Analyse destination
    tip1: "Vérifiez la météo et la haute saison avant de réserver, ça change tout sur place.",
    tip2: "Apprenez 5 mots dans la langue locale — \"bonjour\" et \"merci\" font toujours sourire.",
    // Étape 2 — Recherche des spots
    tip3: "Le matin tôt et l'heure dorée : meilleure lumière pour les photos et moins de foule.",
    tip4: "Mélangez incontournables et coins méconnus pour une expérience plus authentique.",
    // Étape 3 — Sélection restaurants
    tip5: "Goûtez la street food : c'est souvent la plus authentique et la plus économique.",
    tip6: "Demandez aux locaux où ils mangent — les meilleures adresses sont rarement sur les guides.",
    // Étape 4 — Hébergements
    tip7: "Un quartier central vaut mieux qu'un hôtel luxueux excentré : vous gagnez du temps.",
    tip8: "Lisez les avis récents : un bon établissement peut changer en quelques mois.",
    // Étape 5 — Finalisation
    tip9: "Gardez une copie numérique de vos documents importants dans le cloud.",
    tip10: "Réservez vos activités phares à l'avance, mais laissez de la place à l'imprévu.",
  },

  // Results page
  results: {
    transportOptions: "Options de transport",
    transportSubtitle: "Sélectionnez votre mode de transport préféré.",
    continueBtn: "Continuer — Planifier l'itinéraire",
    roadRoute: "Itinéraire routier",
    vehicleType: "Type de véhicule",
    departureIcon: "Départ",
    arrivalIcon: "Arrivée",
    tollIcon: "Péage",
    fuelIcon: "Station essence",
  },

  // Itinerary view
  itinerary: {
    roadTrip: "Road Trip",
    itineraryLabel: "Itinéraire",
    summary: "Récap",
    chatPlaceholder: "Modifiez l'itinéraire...",
    updated: "Itinéraire mis à jour !",
    nightSpot: "Spot nuit",
    park4night: "Park4Night",
    franciaPassion: "France Passion",
    nightsTitle: "Durée par étape",
    nightsHint: "Fixe le nombre de nuits par ville (le total doit correspondre à la durée du séjour).",
    nightsUnit: "nuits",
    nightsMismatch: "Total des nuits ({n}) ≠ durée du séjour ({d}). Ajuste pour coller au planning.",
    noSelectionYet: "Aucune sélection pour le moment",
    toggleView: "Changer de vue",
  },

  // Summary page
  summary: {
    title: "Récapitulatif",
    destination: "Destination",
    duration: "Durée",
    travelersLabel: "Voyageurs",
    transport: "Transport",
    selectedTransport: "Transport sélectionné",
    estimatedBudget: "Budget estimé",
    transportBudget: "Transport",
    activitiesBudget: "Activités",
    foodBudget: "Restauration",
    totalEstimated: "Total estimé",
    mapTitle: "Carte de l'itinéraire",
    pdf: "PDF",
    loginToSave: "Connectez-vous pour sauvegarder",
    tripSaved: "Voyage sauvegardé !",
    publicLink: "Lien public",
    tagline: "VOTRE ITINÉRAIRE PERSONNALISÉ",
    printToc: "Sommaire",
    printDayLabel: "Jour",
    activitiesCountLabel: "activités",
    printPageLabel: "Page",
    bonVoyage: "Bon voyage ! 🌍✈️",
    printFooterDesc: "Itinéraire généré par Globr. Retrouvez et modifiez votre voyage sur mongrandepart.lovable.app",
    allRightsReserved: "Tous droits réservés",
    recoBadge: "Reco",
    publicShareRestricted: "Le partage public est réservé aux forfaits Voyageur et plus.",
  },

  // Auth page
  auth: {
    welcomeBack: "Bon retour !",
    createAccount: "Créer un compte",
    loginSubtitle: "Connectez-vous pour retrouver vos voyages",
    signupSubtitle: "Inscrivez-vous pour sauvegarder vos itinéraires",
    displayName: "Nom d'affichage",
    namePlaceholder: "Votre nom",
    email: "Email",
    emailPlaceholder: "vous@exemple.com",
    password: "Mot de passe",
    login: "Se connecter",
    signup: "S'inscrire",
    noAccount: "Pas encore de compte ?",
    hasAccount: "Déjà un compte ?",
    loginSuccess: "Connexion réussie !",
    checkEmail: "Vérifiez votre email pour confirmer votre inscription !",
    authError: "Erreur d'authentification",
    forgotPassword: "Mot de passe oublié ?",
    forgotDesc: "Entrez votre email pour recevoir un lien de réinitialisation",
    sendResetLink: "Envoyer le lien",
    backToLogin: "Retour à la connexion",
    resetEmailSent: "Email de réinitialisation envoyé !",
    passwordMismatch: "Les mots de passe ne correspondent pas",
    passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères",
    passwordUpdated: "Mot de passe mis à jour !",
    redirecting: "Redirection...",
    invalidResetLink: "Lien invalide",
    invalidResetLinkDesc: "Ce lien de réinitialisation n'est pas valide ou a expiré.",
    backToLoginBtn: "Retour à la connexion",
    newPassword: "Nouveau mot de passe",
    newPasswordDesc: "Entrez votre nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    updatePassword: "Mettre à jour",
    changePassword: "Changer le mot de passe",
    currentPassword: "Mot de passe actuel",
    passwordChanged: "Mot de passe modifié avec succès !",
    changePasswordDesc: "Entrez votre nouveau mot de passe",
    promoCodeLabel: "Code promo (optionnel)",
    promoCodePlaceholder: "Entrez votre code promo",
    promoCodeHint: "Vous avez un code promo ? Entrez-le pour obtenir des recherches gratuites.",
    promoApplied: "Code promo appliqué avec succès !",
    promoInvalid: "Code promo invalide ou expiré.",
    referralCodeLabel: "Code de parrainage (optionnel)",
    referralCodePlaceholder: "Entrez le code d'un ami",
    referralCodeHint: "Un ami vous a parrainé ? Entrez son code pour obtenir des recherches bonus.",
    referralApplied: "Parrainage appliqué ! Recherches bonus ajoutées.",
    referralInvalid: "Code de parrainage invalide.",
    acceptTermsLabel: "J'accepte les CGU/CGV et reconnais que tout abonnement (mensuel ou annuel) engage pour une durée minimum de 12 mois, reconductible tacitement.",
    acceptTermsRequired: "Vous devez accepter les CGU/CGV pour créer un compte.",
    cguLink: "CGU/CGV",
  },

  // My Trips page
  myTrips: {
    title: "Mes voyages",
    noTrips: "Aucun voyage sauvegardé",
    noTripsDesc: "Planifiez votre premier voyage et sauvegardez-le !",
    loadError: "Erreur chargement des voyages",
    deleteSuccess: "Voyage supprimé",
    deleteError: "Erreur suppression",
    filterAll: "Tous",
    filterDrafts: "Brouillons",
    filterFinal: "Voyages",
    draftBadge: "Brouillon",
    actionsLabel: "Actions",
    favoriteLabel: "Favori",
    tripPromptTitle: "Comment s'est passé ce voyage ?",
    tripPromptDesc: "Partage ton expérience à {city} avec la communauté : bons plans, conseils, anecdotes...",
    tripPromptCta: "Partager mon expérience",
    tripPromptDismiss: "Non merci",
    tripPromptDefaultTitlePrefix: "Mon expérience à",
  },

  // My Lists page
  myLists: {
    title: "Mes listes",
    noLists: "Aucune liste",
    noListsDesc: "Sauvegardez des recherches dans des listes depuis vos résultats.",
    noSearches: "Aucune recherche sauvegardée",
    deleteSuccess: "Liste supprimée",
    searchDeleteSuccess: "Recherche supprimée",
    deleteError: "Erreur suppression",
  },

  // Preferences (defaults saved on the account)
  preferences: {
    defaultsApplied: "Tes préférences ont été appliquées",
    readyTripApplied: "Voyage prêt à partir chargé — tu peux ajuster avant de générer",
    reuseTitle: "Réutiliser tes préférences ?",
    reuseDesc: "Tu as {n} réponses enregistrées sur ton compte. Réutilise-les tout de suite ou repars de zéro.",
    startFresh: "Nouvelles préférences",
    reuse: "Réutiliser",
    saveAsDefaults: "Mes préférences",
    saveAsDefaultsTitle: "Sauvegarder ces filtres et goûts comme préférences par défaut sur mon compte",
    saved: "Préférences sauvegardées sur ton compte",
  },

  // Discussion page (community forum)
  discussion: {
    title: "Discussion voyageurs",
    subtitle: "Échangez avec la communauté : retours d'expérience, bons plans, conseils.",
    myProfile: "Mon profil",
    searchPlaceholder: "Rechercher un sujet, une ville...",
    newPost: "Nouveau sujet",
    locationPlaceholder: "Lieu (ville, pays...) — optionnel",
    pickCountry: "Pays concerné — optionnel",
    publish: "Publier",
    hideMap: "Masquer la carte",
    showMap: "Filtrer sur la carte du monde",
    empty: "Aucun sujet pour ce filtre. Sois le premier à lancer la conversation !",
    save: "Enregistrer",
    saved: "Sauvé",
    unsaved: "Retiré de tes favoris",
    reuseItinerary: "Réutiliser l'itinéraire",
    report: "Signaler",
    reply: "Répondre",
    loadMoreReplies: "Charger {n} réponse(s) de plus",
    replyingTo: "Réponse à un commentaire",
    replyPlaceholder: "Écris ta réponse...",
    reportTitle: "Signaler ce contenu",
    reportDesc: "Aide-nous à garder la communauté saine. Décris brièvement le problème (spam, propos inappropriés, fausses informations…).",
    reportPlaceholder: "Raison du signalement (optionnel)",
    confirmReport: "Confirmer le signalement",
    alreadyReported: "Tu as déjà signalé ce contenu.",
    reportSent: "Signalement envoyé. Merci !",
    titlePlaceholder: "Titre",
    contentPlaceholder: "Partage ton expérience, ta question...",
    like: "J'aime",
    send: "Envoyer",
    titleContentRequired: "Titre (≥3) et contenu (≥10) requis",
    postPublished: "Post publié !",
    photosLabel: "Photos",
    addPhotoButton: "Ajouter",
    deletePhotoLabel: "Supprimer la photo",
    photosWord: "photos",
    eachWord: "chacune",
    photoAlt: "Photo",
    uploadingPhoto: "Envoi photo",
    rateLimited: "Tu publies trop vite ! Réessaie dans quelques minutes.",
    paywallDesc: "La discussion entre voyageurs est réservée aux abonnés {plans}. Échangez retours d'expérience, bons plans et conseils avec la communauté.",
    paywallPlans: "Explorer et Famille",
    paywallCta: "Découvrir les forfaits",
    cat: {
      all: "Tous",
      travel: "Voyages",
      app: "L'app",
      city: "Villes",
      activity: "Activités",
    },
  },

  // Legal page
  legal: {
    title: "Informations légales",
    mentions: "Mentions légales",
    cgu: "CGU / CGV",
    privacy: "Confidentialité",
  },

  // 404
  notFound: {
    title: "404",
    message: "Oops ! Page introuvable",
    goHome: "Retour à l'accueil",
  },

  // Testimonials
  testimonials: {
    title: "Ce qu'en pensent nos",
    titleHighlight: "voyageurs",
    subtitle: "+5 000 itinéraires créés — Rejoignez la communauté",
  },

  // Footer
  footer: {
    mentions: "Mentions légales",
    cgu: "CGU",
    privacy: "Politique de confidentialité",
    guide: "Notre Guide",
    rights: "Tous droits réservés.",
    tagline: "La communauté des voyageurs",
  },

  continents: {
    europe: "Europe",
    africa: "Afrique",
    asia: "Asie",
    americas: "Amériques",
    oceania: "Océanie",
    middleEast: "Moyen-Orient",
  },

  // Popular destinations countries
  countries: {
    maroc: "Maroc",
    espagne: "Espagne",
    japon: "Japon",
    italie: "Italie",
    portugal: "Portugal",
    thailande: "Thaïlande",
    turquie: "Turquie",
    etatsunis: "États-Unis",
  },

  airport: {
    selectTitle: "Choisir un aéroport d'arrivée",
    selectSubtitle: "Aéroports disponibles",
    sortedByProximity: "Triés par proximité depuis",
    closest: "Le plus proche",
    change: "Changer",
  },

  map: {
    clickToSelect: "Cliquez sur la carte pour choisir une destination",
    zoomIn: "Zoom avant",
    zoomOut: "Zoom arrière",
    reset: "Réinitialiser",
    showAll: "Tous",
    showVisited: "Visités",
    showUnvisited: "À découvrir",
  },

  // Landing page
  landing: {
    seoTitle: "Globr — Planifiez votre voyage sur mesure",
    seoDescription: "Itinéraires personnalisés, comparaison multi-transport, guide visa et cartes interactives pour +30 000 villes et pays répertoriés.",
    heroTag: "Conçu par des voyageurs, pour des voyageurs",
    heroTitle1: "Voyagez l'esprit léger,",
    heroTitle2: "sans le prix d'une agence",
    heroSubtitle: "Fini les heures passées à comparer vols, hôtels et activités sur dix onglets différents. On s'occupe de tout et on vous propose un itinéraire sur mesure — jusqu'à 70 % moins cher qu'une agence de voyage classique.",
    heroPriceBadge: "💶 Jusqu'à 70 % moins cher qu'une agence",
    heroTrustNote: "Sans engagement · Annulable en un clic · Premier itinéraire offert",
    startFree: "Créer mon itinéraire",
    pricingSingleTitle: "Recherche unique",
    pricingSinglePrice: "5€",
    pricingSingleUnit: "/ 1 recherche",
    pricingSingleDesc: "Visible 7 jours sur le compte",
    pricingSingleItems: "1 itinéraire généré,Visible 7 jours,Sans partage,Sans accès forum",
    pricingSingleCta: "Acheter une recherche",
    pricingPerTitle: "Explorer",
    pricingPerPrice: "12,99€",
    pricingPerUnit: "/ mois ou 99€/an",
    pricingPerDesc: "Le plus populaire",
    pricingPerPopular: "Recommandé",
    pricingPerItems: "Itinéraires illimités,Hôtels inclus,Export PDF propre (sans filigrane),Personnalisation avancée,Accès au forum & carte communauté",
    pricingPerCta: "Choisir Explorer",
    pricingYearTitle: "Pro / Agence",
    pricingYearPrice: "29,99€",
    pricingYearUnit: "/ mois ou 249€/an",
    pricingYearDesc: "Conciergeries & blogueurs voyage",
    pricingYearItems: "Recherches illimitées,Marque blanche PDF,API & export,Multi-comptes,Support prioritaire",
    pricingYearCta: "Choisir Pro",
    pricingBillingMonthly: "Mensuel",
    pricingBillingYearly: "Annuel",
    pricingBillingSave: "−36%",
    pricingSingleFor: "Pour tester sans engagement — paiement unique",
    pricingPerFor: "Pour les voyageurs réguliers — abonnement",
    pricingYearFor: "Pour pros, agences & créateurs — abonnement",
    pricingPerPriceM: "12,99€",
    pricingPerUnitM: "/ mois",
    pricingPerPriceY: "99€",
    pricingPerUnitY: "/ an",
    pricingPerHintM: "Sans engagement, résiliable à tout moment",
    pricingPerHintY: "Soit 8,25€/mois — 2 mois offerts",
    pricingYearPriceM: "29,99€",
    pricingYearUnitM: "/ mois",
    pricingYearPriceY: "249€",
    pricingYearUnitY: "/ an",
    pricingYearHintM: "Sans engagement, résiliable à tout moment",
    pricingYearHintY: "Soit 20,75€/mois — 2 mois offerts",
    testimonialsTitle: "Ce qu'en disent",
    testimonialsTitleHighlight: "nos voyageurs",
    testimonial1Name: "Sophie L.",
    testimonial1Text: "J'ai planifié mon road trip en Italie en 2 minutes. L'itinéraire était parfait !",
    testimonial1City: "Paris",
    testimonial2Name: "Marc D.",
    testimonial2Text: "Le PDF exporté est magnifique, je l'ai montré à tout mon groupe et on a suivi le programme à la lettre.",
    testimonial2City: "Lyon",
    testimonial3Name: "Amina K.",
    testimonial3Text: "Choisir le Japon comme pays et avoir les aéroports triés, c'est génial. Gain de temps énorme.",
    testimonial3City: "Bruxelles",
    faqTitle: "Questions",
    faqTitleHighlight: "fréquentes",
    faq1Q: "Comment fonctionne la génération d'itinéraire ?",
    faq1A: "Notre travel planner analyse votre destination, vos dates, votre budget et vos préférences pour créer un programme sur mesure avec des activités, restaurants et transports locaux optimisés.",
    faq2Q: "Est-ce que je peux choisir un pays entier ?",
    faq2A: "Oui ! Quand vous sélectionnez un pays, l'app vous propose automatiquement les aéroports d'arrivée triés par proximité avec votre premier point d'intérêt.",
    faq3Q: "Comment fonctionne le mode Road Trip ?",
    faq3A: "Activez le mode Road Trip pour planifier un trajet en voiture avec jusqu'à 8 étapes intermédiaires, calcul automatique du carburant et des péages, et stations-service sur la route.",
    faq4Q: "Puis-je partager mon itinéraire ?",
    faq4A: "Absolument. Générez un lien public que n'importe qui peut consulter sans créer de compte, ou exportez un PDF professionnel.",
    faq5Q: "Quels sont les modes de paiement acceptés ?",
    faq5A: "Tous les paiements (recherche unique et abonnements) sont traités par Stripe, notre prestataire de paiement sécurisé certifié PCI-DSS. Nous acceptons les cartes bancaires Visa, Mastercard et American Express. Aucune donnée bancaire n'est stockée sur nos serveurs.",
    faq6Q: "Puis-je modifier un itinéraire après génération ?",
    faq6A: "Vous pouvez sauvegarder vos itinéraires dans vos listes et relancer une génération avec des paramètres différents à tout moment.",
    ctaTitle: "Prêt pour le",
    ctaTitleHighlight: "grand départ",
    ctaSubtitle: "Pas d'agence, pas de frais cachés : votre itinéraire sur mesure en quelques minutes, jusqu'à 70 % moins cher.",
    ctaBtn: "Planifier mon voyage",
    navHow: "Fonctionnement",
    navFeatures: "Fonctionnalités",
    navPricing: "Tarifs",
    navFaq: "FAQ",
    plan: "Mon espace",
    login: "Connexion",
    mockRoute: "Paris → Tokyo",
    mockDays: "7 jours",
    mockActivities: "12 activités",
    statsItineraries: "Itinéraires créés",
    mobileTitle: "Emportez Globr partout",
    mobileDesc: "Installez l'application sur votre téléphone pour y accéder hors ligne, comme une vraie app mobile.",
    mobileIos1: "Ouvrez le site dans Safari",
    mobileIos2: "Appuyez sur l'icône de partage",
    mobileIos3: "Sélectionnez « Sur l'écran d'accueil »",
    mobileAndroid1: "Ouvrez le site dans Chrome",
    mobileAndroid2: "Appuyez sur le menu ⋮",
    mobileAndroid3: "Sélectionnez « Ajouter à l'écran d'accueil »",
    visaGuideTag: "Guide pratique",
    visaGuideTitle: "Visa, travail, études :",
    visaGuideHighlight: "tout savoir avant de partir",
    visaGuideDesc: "Pour chaque pays : conditions de visa, permis de travail, visas étudiants, double nationalité, coût de la vie. Préparez sereinement votre départ.",
    visaGuideCta: "Consulter le guide visa",
    visaGuideLink: "Consulter le guide visa pour",
    howItWorks: "Comment ça marche",
    howTitle: "Votre voyage en",
    howTitleHighlight: "4 étapes simples",
    howSubtitle: "De l'idée au départ, on s'occupe de tout.",
    step1Title: "Choisissez votre destination",
    step1Desc: "Pays, ville ou inspiration : explorez +30 000 villes et pays avec recherche intelligente.",
    step2Title: "Précisez vos dates et budget",
    step2Desc: "Indiquez vos dates, le nombre de voyageurs et votre budget pour un itinéraire sur mesure.",
    step3Title: "Recevez votre itinéraire",
    step3Desc: "Vous recevez un programme jour par jour avec activités, restaurants et transports, prêt à suivre.",
    step4Title: "Partez l'esprit tranquille",
    step4Desc: "Exportez en PDF, partagez avec vos proches et accédez à votre voyage hors-ligne.",
    featuresTitle: "Tout ce qu'il faut",
    featuresTitleHighlight: "pour bien voyager",
    featuresSubtitle: "Une suite complète d'outils pour planifier, comparer et profiter.",
    feature1Title: "Itinéraires personnalisés",
    feature1Desc: "6 à 10 activités par jour adaptées à vos centres d'intérêt, votre budget et la saison.",
    feature2Title: "Comparaison transports",
    feature2Desc: "Vols, trains, bus et voiture comparés en temps réel, avec liens directs vers les opérateurs.",
    feature3Title: "Visa & sécurité",
    feature3Desc: "Conditions d'entrée, vaccins et niveau de sécurité mis à jour pour 200+ pays.",
    feature4Title: "Mode road trip",
    feature4Desc: "Jusqu'à 8 étapes, calcul du carburant, des péages et des aires de stationnement.",
    feature5Title: "Cartes interactives",
    feature5Desc: "Visualisez votre itinéraire sur une carte, avec activités, hôtels et points d'intérêt.",
    feature6Title: "Export PDF & partage",
    feature6Desc: "PDF élégant 1 jour par page et lien public sécurisé pour partager en un clic.",
    pricingTitle: "Des tarifs",
    pricingTitleHighlight: "simples et clairs",
    pricingSubtitle: "Essayez gratuitement, payez seulement si vous adorez.",
    trustTravelers: "+12 800 voyageurs",
    trustDestinations: "+30 000 villes répertoriées",
    heroCities: "+30 000 villes répertoriées dans le monde",
    communityTag: "Communauté",
    communityTitle: "Rejoignez une communauté",
    communityTitleHighlight: "de voyageurs passionnés",
    communitySubtitle: "Partagez vos itinéraires, découvrez ceux des autres et inspirez-vous des récits du monde entier.",
    communityFeat1Title: "Carte mondiale",
    communityFeat1Desc: "Visualisez les pays visités par la communauté et découvrez de nouvelles inspirations.",
    communityFeat2Title: "Forum d'échange",
    communityFeat2Desc: "Posez vos questions, partagez vos bons plans et lisez les retours d'expérience.",
    communityFeat3Title: "Profils voyageurs",
    communityFeat3Desc: "Suivez d'autres globe-trotters et inspirez-vous de leurs itinéraires publics.",
    communityCta: "Découvrir la carte",
    communityProfileCta: "Voir les profils",
    communityMapHint: "Cliquez sur un pays pour explorer les voyages de la communauté.",
    heroImageAlt: "Destination de voyage Globr — visuel",
  },

  signupBanner: {
    title: "Créez votre compte pour continuer",
    desc: "Inscrivez-vous pour sauvegarder vos itinéraires et accéder aux recherches via Stripe (recherche unique ou abonnement).",
    cta: "Créer mon compte",
    login: "J'ai déjà un compte",
  },

  // Admin
  admin: {
    title: "Administration",
    users: "Utilisateurs",
    search: "Rechercher...",
    noName: "Sans nom",
    registeredOn: "Inscrit le",
    loading: "Chargement...",
    noUsers: "Aucun utilisateur trouvé",
    deleteConfirm: "Supprimer",
    roleAdded: "Rôle ajouté",
    roleRemoved: "Rôle retiré",
    loadError: "Erreur chargement",
    deleteSuccess: "Utilisateur supprimé",
    deleteError: "Erreur suppression",
    back: "Retour",
  },

  // Shared itinerary
  shared: {
    title: "Itinéraire partagé",
    notFound: "Itinéraire introuvable",
    notFoundDesc: "Ce lien de partage n'est pas valide ou l'itinéraire a été supprimé.",
    backHome: "Retour à l'accueil",
    createdWith: "Créé avec Globr",
    back: "Retour",
    share: "Partager",
    linkCopied: "Lien copié !",
    destination: "Destination",
    duration: "Durée",
    travelers: "Voyageurs",
    departure: "Départ",
    days: "{n} jours",
    day: "Jour",
    planTrip: "Planifier mon voyage",
    filtersTitle: "Filtres & goûts de ce voyage",
  },

  settings: {
    title: "Paramètres",
    profile: "Profil",
    displayName: "Nom d'affichage",
    connectedVia: "Connecté via",
    changeEmail: "Changer d'email",
    changeEmailDesc: "Un email de confirmation sera envoyé aux deux adresses.",
    newEmail: "Nouvel email",
    updateEmail: "Mettre à jour l'email",
    emailConfirmSent: "Un email de confirmation a été envoyé.",
    changePassword: "Changer le mot de passe",
    changePasswordDesc: "Minimum 6 caractères.",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    updatePassword: "Mettre à jour le mot de passe",
    passwordMismatch: "Les mots de passe ne correspondent pas.",
    passwordTooShort: "Le mot de passe doit faire au moins 6 caractères.",
    passwordUpdated: "Mot de passe mis à jour avec succès.",
    nameUpdated: "Nom mis à jour.",
    profilePhoto: "Photo de profil",
    profilePhotoDesc: "Cliquez pour changer (max 2MB)",
    avatarUpdated: "Photo de profil mise à jour.",
    subscription: "Abonnement",
    subscriptionDesc: "Gérez votre formule et vos paiements.",
    freePlan: "Sans abonnement actif",
    freePlanDesc: "1 itinéraire gratuit chaque mois — ou passez à une recherche unique (5 €) ou un abonnement Voyageur, Explorer ou Pro via Stripe.",
    singleSearchPaid: "Recherche débloquée pour 7 jours !",
    offlineReassurance: "Tous vos voyages, y compris en formule Découverte, restent accessibles hors-ligne.",
    active: "Actif",
    upgradePlan: "Passer à un plan supérieur",
    perSearchPlan: "À la recherche",
    perSearchDesc: "Paiement unique pour une recherche d'itinéraire complète.",
    buySearch: "Acheter une recherche",
    annualPlan: "Illimité annuel",
    annualDesc: "Recherches illimitées pendant 1 an.",
    subscribe: "S'abonner",
    bestValue: "Meilleur rapport qualité-prix",
    renewsOn: "Renouvellement le",
    manageSubscription: "Gérer mon abonnement",
    refreshStatus: "Actualiser le statut",
    checkoutSuccess: "Paiement réussi ! Votre abonnement est actif.",
    checkoutCancelled: "Paiement annulé.",
    signOut: "Se déconnecter",
    deleteAccount: "Supprimer mon compte",
    deleteAccountTitle: "Supprimer définitivement votre compte ?",
    deleteAccountWarning: "Cette action est irréversible. Toutes vos données (profil, voyages, listes, recherches, contributions, photos d'avatar) seront supprimées définitivement, conformément au RGPD.",
    deleteAccountTypeToConfirm: "Tapez SUPPRIMER pour confirmer :",
    deleteAccountConfirm: "Supprimer définitivement",
    deleteAccountConfirmRequired: "Tapez SUPPRIMER pour confirmer",
    accountDeleted: "Compte supprimé.",
    deleteAccountHint: "La suppression est définitive et conforme au RGPD.",
    referral: "Parrainage",
    referralDesc: "Partagez votre code et gagnez des recherches gratuites.",
    yourReferralCode: "Votre code de parrainage",
    copyCode: "Copier",
    codeCopied: "Code copié !",
    referralCount: "Filleuls",
    referralBonus: "recherches bonus gagnées",
    shareReferral: "Partager mon code",
    paymentPending: "Paiement en cours de validation…",
    avatarMaxSize: "Taille maximale : 2 Mo",
    avatarUploadError: "Erreur lors de l'envoi de la photo",
    checkoutError: "Erreur lors du paiement",
    deleteAccountError: "Erreur lors de la suppression",
    deleteAccountConfirmWord: "SUPPRIMER",
    manageFamilyProfiles: "Gérer les profils Famille",
    newEmailPlaceholder: "nouveau@email.com",
    singleSearchTitle: "Recherche unique",
    noCommitment: "Sans engagement",
    perSearchUnit: "/ 1 recherche",
    singleSearchFeature1: "1 itinéraire généré",
    singleSearchFeature2: "Visible 7 jours sur le compte",
    singleSearchFeature3: "Sans partage, sans accès forum",
    buySingleSearchButton: "Acheter une recherche (5 €)",
    billingMonthly: "Mensuel",
    billingYearly: "Annuel",
    billingYearlyDiscount: "jusqu'à -36%",
    recommendedBadge: "Recommandé",
    plans: {
      voyageur: {
        name: "Voyageur",
        feature1: "10 recherches/mois",
        feature2: "Export PDF",
        feature3: "Road trip 5 étapes",
        feature4: "Partage illimité",
        cta: "Choisir Voyageur",
      },
      explorer: {
        name: "Explorer",
        feature1: "40 recherches/mois",
        feature2: "Road trip 8 étapes",
        feature3: "Profils famille illimités",
        feature4: "Modération prioritaire",
        cta: "Choisir Explorer",
      },
      pro: {
        name: "Pro / Agence",
        feature1: "Recherches illimitées",
        feature2: "PDF marque blanche",
        feature3: "API / export",
        feature4: "Multi-comptes",
        cta: "Choisir Pro",
      },
    },
    referralShareTextPrefix: "Rejoins Globr avec mon code",
    referralShareTextSuffix: "et obtiens des recherches gratuites !",
  },

  guide: {
    tag: "Guide pratique",
    title: "Guide des",
    titleHighlight: "Visas & Démarches",
    subtitle: "Tout ce qu'il faut savoir sur les visas, permis de travail, études et expatriation pour chaque destination.",
    searchPlaceholder: "Rechercher un pays...",
    allContinents: "Tous les continents",
    visaRequired: "Visa requis",
    visaFree: "Sans visa",
    tourism: "Tourisme",
    tourismShort: "Tourisme",
    work: "Travailler",
    workShort: "Travail",
    study: "Étudier",
    studyShort: "Études",
    live: "S'installer",
    liveShort: "Vivre",
    visaStatus: "Statut du visa",
    duration: "Durée de séjour",
    cost: "Coût",
    requirements: "Documents requis",
    tips: "Conseils pratiques",
    applyEVisa: "Demander le e-Visa",
    dualNationality: "Double nationalité",
    allowed: "Autorisée",
    notAllowed: "Non autorisée",
    healthSystem: "Système de santé",
    costOfLiving: "Coût de la vie",
    disclaimer: "Ces informations sont fournies à titre indicatif et peuvent évoluer. Consultez toujours les sites officiels des gouvernements pour les exigences les plus récentes.",
    translating: "Traduction en cours…",
    currencyTitle: "Convertisseur de devise",
    currencyError: "Taux de change indisponible. Réessayez plus tard.",
    currencySwap: "Inverser la conversion",
    currencyLive: "Taux mis à jour quotidiennement",
    currencyRefresh: "Actualiser le taux",
    currencyDisclaimer: "Taux indicatif fourni à titre d'information. Source :",
    currencyUpdatedOn: "mis à jour le",
    eurCountryTitle: "Ce pays utilise l'euro (€)",
    eurCountryNote: "Aucun convertisseur n'est nécessaire : la monnaie locale est la même que la vôtre si vous voyagez depuis la zone euro.",
    lastTranslated: "Dernière traduction",
    clearTranslationCache: "Forcer une nouvelle traduction",
    cacheBannerTitle: "Données affichées depuis le cache local",
    cacheBannerDesc: "Traduction et taux de change peuvent dater. Actualisez pour récupérer les dernières valeurs.",
    cacheBannerRefresh: "Tout actualiser",
    cacheBannerRefreshing: "Actualisation en cours…",
    cacheBannerRefreshingDesc: "Récupération de la dernière traduction et du taux de change le plus récent.",
    cacheTranslationLabel: "Traduction mise en cache le",
    cacheFxLabel: "Taux de change mis en cache le",
    cacheStale: "expiré",
    enrichmentTitle: "Infos pratiques pour préparer votre départ",
    enrichLanguages: "Langues parlées",
    enrichTimezone: "Fuseau horaire",
    enrichElectricity: "Électricité",
    enrichBestTime: "Meilleure période",
    enrichEmergency: "Numéros d'urgence",
    enrichSafety: "Sécurité",
    enrichPopularCities: "Villes populaires",
    enrichSalary: "Salaires",
    enrichTaxation: "Fiscalité",
    enrichConnectivity: "Connectivité",
    enrichTransport: "Transports",
    enrichItineraries: "Itinéraires types",
    budgetBackpacker: "Budget routard / jour",
    budgetMid: "Budget confort / jour",
    budgetComfort: "Budget premium / jour",
    enrichCulturalTips: "Conseils culturels",
    enrichScams: "Arnaques courantes",
    enrichHealth: "Santé & vaccins",
    enrichAccommodation: "Trouver un logement",
    enrichApps: "Apps utiles",
    enrichOfficial: "Sites officiels",
    safetyLevel: { low: "Risque faible", medium: "Vigilance modérée", high: "Vigilance accrue" },
    enrichEmbassy: "Ambassade / Consulat",
    embassyAddress: "Adresse",
    embassyPhone: "Téléphone",
    embassyWebsite: "Site officiel",
    safetyRecommendationsTitle: "Recommandations selon le niveau",
    safetyRecos: {
      low: [
        "Vigilance standard dans les zones touristiques (pickpockets).",
        "Gardez une copie numérique de vos papiers (passeport, visa).",
        "Souscrivez à une assurance voyage classique.",
      ],
      medium: [
        "Évitez de circuler seul·e la nuit dans les quartiers peu fréquentés.",
        "Privilégiez les VTC officiels plutôt que les taxis hélés en rue.",
        "Consultez régulièrement le site France-Diplomatie avant et pendant le séjour.",
        "Souscrivez une assurance voyage incluant l'évacuation médicale.",
      ],
      high: [
        "Inscrivez-vous sur Ariane (registre des Français à l'étranger).",
        "Limitez les déplacements terrestres et privilégiez l'avion entre régions.",
        "Évitez les rassemblements publics et zones frontalières sensibles.",
        "Conservez les contacts d'urgence de l'ambassade en accès rapide.",
        "Souscrivez une assurance avec rapatriement et couverture risques politiques.",
      ],
    },
    faqTitleEnrich: "Questions fréquentes sur",
    jumpToHealth: "Voir la section santé",
    jumpToAccommodation: "Voir la section logement",
    jumpToTransport: "Voir la section transports",
    jumpToSafety: "Voir la section sécurité",
    jumpToCurrency: "Voir le convertisseur de devise",
    relatedSections: "Sections liées",
    faq: {
      visaQ: "Ai-je besoin d'un visa pour {country} ?",
      visaA: "{answer}",
      visaAYes: "Oui, un visa est requis. Durée : {duration}.",
      visaANo: "Non, {country} est accessible sans visa pour de nombreux ressortissants. {visaFreeFor} Durée : {duration}.",
      durationQ: "Combien de temps puis-je rester ?",
      durationA: "{duration}",
      bestTimeQ: "Quelle est la meilleure période pour partir ?",
      bestTimeA: "{bestTime}",
      currencyQ: "Quelle monnaie utilise-t-on à {country} ?",
      currencyA: "La monnaie locale est le {name} ({code}, symbole {symbol}).",
      currencyEurA: "{country} utilise l'euro (€), aucune conversion nécessaire depuis la zone euro.",
      safetyQ: "Le pays est-il sûr pour les voyageurs ?",
      safetyA: "{note}",
      healthQ: "Faut-il des vaccins particuliers ?",
      healthA: "{advice}",
      languageQ: "Quelles langues sont parlées ?",
      languageA: "Langues principales : {langs}.",
      costQ: "Quel est le coût de la vie ?",
      costA: "{cost}",
    },
    breadcrumbHome: "Accueil",
    currency: "Devise",
    practical: "Vie pratique",
    h1: "Guide complet des visas et démarches administratives",
    h1Country: "Guide et conseils",
    sectionTourism: "Visa touristique",
    sectionWork: "Travailler",
    sectionStudy: "Étudier",
    sectionLive: "S'installer durablement",
    seoTitle: "Guide et conseils voyage : visa, sécurité, santé, budget | Globr",
    seoDescription: "Guide et conseils pratiques pour 27+ pays : visa, sécurité, santé, budget, transports, culture et coût de la vie. Tout pour préparer votre départ sereinement.",
    seoTitleCountry: "{country} : guide et conseils voyage (visa, sécurité, budget) | Globr",
    seoDescriptionCountry: "Guide complet pour {country} : visa et démarches, sécurité, santé, budget, transports, culture et conseils pratiques pour bien préparer votre voyage.",
    sectionsNav: "Sections du guide",
    clearSearch: "Effacer",
    continentFiltersNav: "Filtres par continent",
    tocNav: "Sommaire",
  },

  nav2: {
    guide: "Notre Guide",
  },

  plan: {
    recapTitle: "Récapitulatif de votre voyage",
    recapSubtitle: "Vérifie les informations avant de générer ton itinéraire complet.",
    budget: "Niveau de budget",
    travelMode: "Mode de transport",
    flightMode: "Avion / Train",
    noInterests: "Aucun centre d'intérêt sélectionné",
    openGuideTitle: "Consulter le guide complet",
    openGuideDesc: "Visa, santé, sécurité, coût de la vie et conseils pratiques.",
    disclaimer: "Cet aperçu reste indicatif. L'itinéraire final est généré sur mesure à partir de tes critères.",
    editTrip: "Modifier",
    launchSearch: "Lancer la recherche",
  },
  offline: {
    title: "Hors-ligne",
    intro: "Voyages disponibles sans connexion :",
    youAreOffline: "Vous êtes hors-ligne — voici ce qui est disponible :",
    empty: "Aucun voyage hors-ligne",
    emptyDesc: "Depuis Mes voyages, choisis « Garder hors-ligne ».",
    keepAction: "Garder hors-ligne",
    removeAction: "Retirer du hors-ligne",
    saved: "Disponible hors-ligne",
    removed: "Retiré du hors-ligne",
    viewItinerary: "Voir l'itinéraire",
    syncNow: "Synchroniser",
    synced: "Voyages synchronisés",
    upToDate: "Déjà à jour",
    syncError: "Échec de synchronisation",
    lastSync: "Dernière sync",
    serverDeletedTitle: "Supprimés côté serveur",
    serverDeletedDesc: "Ces voyages n'existent plus sur le serveur. Souhaitez-vous les retirer du cache hors-ligne ?",
    keep: "Garder",
    remove: "Retirer",
    confirmRemoveTitle: "Retirer du hors-ligne ?",
    confirmRemoveDesc: "Ce voyage a été supprimé côté serveur. Le retirer du cache effacera définitivement la copie locale.",
    conflictsTitle: "Conflits de synchronisation",
    conflictsDesc: "La version serveur a remplacé vos modifications hors-ligne. Une copie locale a été conservée :",
  },

  plans: {
    free: { shortLabel: "Découverte" },
    voyageur: { shortLabel: "Voyageur" },
    explorer: { shortLabel: "Explorer" },
    pro: { shortLabel: "Pro / Agence" },
  },

  theme: {
    enableLight: "Activer le thème clair",
    enableDark: "Activer le thème sombre",
  },

  mobile: {
    home: "Accueil",
    quickSearchPlaceholder: "Où voulez-vous partir ?",
    quickSearchLabel: "Recherche rapide",
    quickStart: "Départ rapide",
  },

  routeMap: {
    departure: "Départ",
    arrival: "Arrivée",
    tollZone: "Zone à péage",
  },

  activityCard: {
    bookRide: "Réserver un trajet :",
    transitMiniPlan: "Mini-plan trajet",
    departure: "Départ",
    arrival: "Arrivée",
    doorToDoor: "Porte-à-porte",
    margin: "Marge",
    understandMargin: "Comprendre la marge",
    show: "afficher",
    hide: "masquer",
    advanceHoursTitle: "Heures d'avance recommandées par mode",
    modeFlight: "Avion",
    modeTrain: "Train",
    modeFerry: "Ferry",
    modeBus: "Bus",
    advance: {
      flight: {
        time: "+2h à 3h",
        usage: "Arrive 2h avant (Schengen) ou 3h avant (international) : enregistrement, dépose bagages, contrôles.",
      },
      train: {
        time: "+20 à 30 min",
        usage: "Présente-toi en gare 20–30 min avant : retrait billet, accès quai, place réservée.",
      },
      ferry: {
        time: "+1h à 2h",
        usage: "1h en piéton, 2h avec véhicule : embarquement, contrôles, chargement.",
      },
      bus: {
        time: "+15 à 20 min",
        usage: "Arrive 15–20 min avant : repérage du quai, dépôt soute, embarquement.",
      },
      car: {
        time: "+15 min",
        usage: "Marge pour trafic, parking et station essence avant départ.",
      },
      default: {
        time: "+30 min",
        usage: "Marge de sécurité standard pour absorber imprévus et correspondances.",
      },
    },
    marginExplainer: "Cette marge est ajoutée au temps porte-à-porte pour calculer ton heure de départ et garantir une transition sereine entre les villes.",
    compareOptionsTitle: "Options de trajet — compare avant de confirmer",
    fast: "Rapide",
    cheap: "Économique",
    recommended: "Recommandé",
    chosen: "Choisi",
    toConfirm: "À confirmer",
    advancePrefix: "Avance",
    comparisonTitle: "Comparatif avant confirmation",
    current: "Actuel",
    plannedChoice: "Choix prévu",
    durationDeltaLabel: "Durée",
    budgetDeltaLabel: "Budget jour",
    before: "Avant",
    after: "Après",
    same: "identique",
    unchangedHalfDays: "Demi-journées inchangées",
    marginVsSuffix: "vs {margin} actuel",
    confirmChoice: "Confirmer ce choix",
  },

  saveToList: {
    trigger: "Liste",
    title: "Sauvegarder dans une liste",
    createPlaceholder: "Créer une nouvelle liste...",
    createError: "Erreur création liste",
    saveError: "Erreur sauvegarde",
    searchSaved: "Recherche sauvegardée !",
    emptyState: "Créez votre première liste ci-dessus",
  },

  shareLinks: {
    ttl7: "7 jours",
    ttl30: "30 jours",
    ttl90: "90 jours",
    ttl365: "1 an",
    title: "Liens de partage public",
    description: "Chaque lien expire automatiquement et peut être régénéré ou révoqué à tout moment.",
    duration: "Durée",
    create: "Créer",
    empty: "Aucun lien actif. Créez-en un ci-dessus.",
    statusActive: "Actif",
    statusRevoked: "Révoqué",
    statusExpired: "Expiré",
    createdOn: "Créé le",
    expiresOn: "Expire le",
    revokedOn: "Révoqué le",
    copy: "Copier",
    regenerate: "Régénérer",
    revoke: "Révoquer",
    revokeConfirm: "Révoquer ce lien ? Il ne sera plus accessible.",
    linkCopied: "Lien copié !",
    linkCreatedCopied: "Lien créé et copié",
    tokenRegenerated: "Token régénéré et copié — l'ancien ne fonctionne plus",
    linkRevoked: "Lien révoqué",
    genericError: "Erreur",
  },

  family: {
    title: "Profils Famille",
    subtitle: "Créez jusqu'à 5 profils pour générer des itinéraires combinant les goûts de toute la famille.",
    subscriptionRequired: "Abonnement requis",
    voyageurLimitMessage: "Le forfait Voyageur autorise 1 profil. Passez à Explorer pour des profils illimités.",
    limitReached: "Limite atteinte",
    nameRequired: "Nom requis",
    profileAdded: "Profil ajouté",
    profileDeleted: "Profil supprimé",
    upsellTitle: "Fonctionnalité Famille",
    upsellDescPart1: "Passez à",
    upsellVoyageurOffer: "Voyageur (6,99€/mois)",
    upsellDescPart2: "pour 1 profil ou",
    upsellExplorerOffer: "Explorer (12,99€/mois)",
    upsellDescPart3: "pour des profils famille illimités.",
    viewPlansButton: "Voir les forfaits",
    addProfileTitle: "Ajouter un profil",
    firstName: "Prénom",
    age: "Âge (optionnel)",
    avatarLabel: "Avatar",
    interestsLabel: "Centres d'intérêt",
    addButton: "Ajouter",
    noProfiles: "Aucun profil pour le moment.",
    yearsUnit: "ans",
  },

  contribute: {
    requiredFieldsError: "Titre, description et ville requis",
    licenseRequiredError: "Merci d'accepter la licence CC BY 4.0 pour publier votre contribution",
    uploadingPhoto: "Envoi photo",
    updatingStatus: "Mise à jour…",
    savingStatus: "Enregistrement…",
    updateSuccess: "Contribution mise à jour",
    submitSuccess: "Contribution envoyée — en attente de modération",
    submitError: "Erreur lors de l'envoi",
    deleteConfirm: "Supprimer cette contribution ?",
    deleteSuccess: "Supprimé",
    withdrawSuccess: "Demande de retrait envoyée à l'équipe de modération",
    headerTitle: "Contribuer",
    heroTitle: "Partagez vos pépites",
    heroSubtitle: "Aidez les autres voyageurs en partageant les activités et restaurants que vous avez adorés. Chaque contribution est validée par notre équipe avant publication.",
    tabNew: "Nouvelle",
    tabMine: "Mes contributions",
    editingNotice: "Modification d'une contribution en attente",
    typeLabel: "Type",
    typeActivity: "Activité",
    typeRestaurant: "Restaurant",
    mainInfoTitle: "Informations principales",
    placeName: "Nom du lieu",
    placeNamePlaceholderRestaurant: "Ex: Chez Marcel",
    placeNamePlaceholderActivity: "Ex: Cascade cachée du Mont Sacré",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Pourquoi c'est génial ? Que faut-il y faire/manger ?",
    cityLabel: "Ville",
    cityPlaceholder: "Lisbonne",
    countryLabel: "Pays",
    countryPlaceholder: "Portugal",
    addressLabel: "Adresse précise",
    photosLabel: "Photos",
    photoAltPrefix: "Photo de",
    photoAltGeneric: "Photo du lieu",
    deletePhotoLabel: "Supprimer la photo",
    addPhotoButton: "Ajouter",
    photosWord: "photos",
    eachWord: "chacune",
    tipsCardTitle: "Conseils pratiques",
    tipsLabel: "Conseils & astuces",
    tipsPlaceholder: "Réservez à l'avance, demandez la spécialité du chef...",
    bestHoursLabel: "Meilleurs horaires",
    bestHoursPlaceholder: "9h-11h ou après 19h",
    crowdLevelLabel: "Fréquentation",
    crowdLevelPlaceholder: "Niveau",
    crowdLow: "Calme",
    crowdMedium: "Modérée",
    crowdHigh: "Très fréquenté",
    isPaidLabel: "Payant ?",
    avgPriceLabel: "Prix moyen / personne (€)",
    licenseCardTitle: "Licence & attribution",
    authorNameLabel: "Nom d'auteur affiché (optionnel)",
    authorNamePlaceholder: "Pseudo, prénom ou laisser vide",
    authorNameHint: "Si vide, votre pseudo de profil sera utilisé pour l'attribution publique.",
    licenseAgreementPrefix: "Je publie sous licence",
    licenseAgreementBody: "Je conserve la propriété de mon contenu (texte + photos). J'autorise Globr et les autres voyageurs à le réutiliser à condition de citer mon attribution. Je certifie détenir les droits sur les photos téléversées et pouvoir demander le retrait à tout moment.",
    preparingStatus: "Préparation…",
    updateButton: "Mettre à jour",
    submitButton: "Envoyer pour modération",
    noContributions: "Aucune contribution pour le moment.",
    statusPending: "En attente",
    statusApproved: "Approuvé",
    statusRejected: "Refusé",
    statusWithdrawalRequested: "Retrait demandé",
    statusWithdrawn: "Retiré",
    reasonLabel: "Motif :",
    withdrawalReasonLabel: "Motif retrait :",
    editTitle: "Modifier",
    requestWithdrawalTitle: "Demander le retrait",
    withdrawButton: "Retirer",
    withdrawDialogDesc: "Votre contribution sera immédiatement masquée du public et envoyée à l'équipe de modération pour suppression définitive (incluant les photos).",
    withdrawReasonLabel: "Motif (optionnel)",
    withdrawReasonPlaceholder: "Lieu fermé, photos à retirer, etc.",
    confirmWithdrawButton: "Confirmer le retrait",
  },

  esim: {
    title: "eSIM recommandées pour",
    subtitle: "Sélection classée selon le prix, la base utilisateurs et la qualité du réseau, avec un bonus pour la couverture locale.",
    cardsViewTitle: "Vue cartes",
    cardsViewLabel: "Cartes",
    compareViewTitle: "Vue comparatif",
    compareViewLabel: "Comparer",
    hideFilters: "Masquer les filtres",
    showFilters: "Filtres & détails",
    filtersLabel: "Filtres",
    resetButton: "Réinitialiser",
    maxPriceLabel: "Prix max",
    minNetworkLabel: "Qualité réseau min.",
    minReputationLabel: "Réputation min. (M utilisateurs)",
    allLabel: "Toutes",
    matchingProvidersLabel: "fournisseur(s) correspondent à tes filtres.",
    defaultRankingNotice: "Affichage du classement par défaut.",
    criteriaHeader: "Critère",
    bestChoiceBadge: "Meilleur choix",
    internalScoreLabel: "Score interne :",
    scoreTooltipSuffix: "(prix, réseau, base utilisateurs, couverture régionale)",
    scoreLabel: "Score",
    priceLabel: "Prix",
    networkLabel: "Réseau",
    userBaseLabel: "Base utilisateurs",
    usersUnit: "utilisateurs",
    strongRegionsLabel: "Régions fortes",
    strengthLabel: "Force",
    linkHeader: "Lien",
    viewOffersLink: "Voir les offres",
    baseLabel: "Base",
    scoreDetailsLabel: "Détails du score",
    exampleLabel: "Ex. :",
    pricingDisclaimer: "Tarifs indicatifs · vérifiez le forfait exact sur le site du fournisseur avant achat.",
  },

  roadtrip: {
    totalDistance: "Distance totale",
    drivingTime: "Temps de route",
    breakTime: "Pauses",
    stopTime: "Arrêts étapes",
    optimizedOrder: "Ordre optimisé",
    ofDriving: "de route",
    stopAt: "Arrêt à",
    arrival: "Arrivée",
    departureDate: "Date de départ",
    departureTime: "Heure de départ",
    stopDuration: "Durée par étape",
    dieselPrice: "Gazole",
    livePrice: "prix en direct",
    stationsNearby: "stations autour du trajet",
    estimatedPrice: "prix estimé (hors France)",
    budgetTitle: "Budget total du road trip",
    budgetFuel: "Carburant",
    budgetTolls: "Péages",
    budgetStay: "Hébergement",
    budgetMeals: "Repas",
    budgetPerPerson: "Par personne",
    budgetTravelers: "voyageurs",
    budgetTraveler: "voyageur",
    budgetDays: "jours",
    budgetNights: "nuits",
    budgetNote: "Estimation : carburant et péages calculés sur le trajet réel, hébergement et repas estimés selon ton niveau de budget.",
    break: {
      break: "Pause",
      meal: "Repas",
      fuel: "Plein",
    },
  },

  carRoute: {
    tollSectionsLabel: "section(s) à péage",
    noTolls: "Sans péage",
    trafficDelaySuffix: "min de trafic",
    smoothTraffic: "Trafic fluide",
    fuelStopsLabel: "arrêt(s) carburant recommandé(s)",
  },

  blog: {
    seoTitle: "Blog voyage : conseils, guides et astuces | Globr",
    seoDescription: "Conseils voyage, guides par pays et astuces pratiques : visa, budget, sécurité, eSIM et transports pour préparer votre prochain départ.",
    h1: "Blog voyage : conseils et guides pratiques",
    intro: "Bienvenue sur le blog Globr. Retrouvez nos guides pratiques par pays — visa, budget, sécurité, eSIM, transports — ainsi que nos conseils pour préparer votre voyage en toute sérénité.",
  },
};
